import { render, staticRenderFns } from "./TrustInfo.vue?vue&type=template&id=43624a4d&scoped=true"
import script from "./TrustInfo.vue?vue&type=script&lang=js"
export * from "./TrustInfo.vue?vue&type=script&lang=js"
import style0 from "./TrustInfo.vue?vue&type=style&index=0&id=43624a4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43624a4d",
  null
  
)

export default component.exports